var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { classNames, tagName, attribute } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
/* eslint square/no-restricted-files:'off' -- unscoped components in this folder are discouraged */
import { isNone } from '@ember/utils';
import { scheduleOnce } from '@ember/runloop';
import Component from '@ember/component';
import Enum from '@square/dashboard-utilities/utils/enum';
import * as d3 from 'd3';
import $ from 'jquery';
const MIN_SPACE_PER_CHAR = 6;
export const RotateOptions = new Enum('NEVER', 'AUTO', 'ALWAYS');
let SqChartAxis = (_dec = classNames('chart-axis'), _dec2 = tagName('g'), _dec3 = observes('scale', 'orient', 'innerTickSize', 'outerTickSize', 'tickFormat', 'tickPadding', 'tickValues', 'ticks', 'majorInnerTickSize', 'transitionDuration', 'transitionEase', 'rotateTicksToFit'), _dec(_class = _dec2(_class = (_class2 = class SqChartAxis extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "transform", _descriptor, this);
    // bind to these from the parent chart component to configure the axis
    // these correspond to the documented getter/setters in d3.svg.axis()
    _defineProperty(this, "scale", null);
    _defineProperty(this, "orient", 'bottom');
    _defineProperty(this, "outerTickSize", 0);
    _defineProperty(this, "innerTickSize", 3);
    _defineProperty(this, "tickFormat", null);
    _defineProperty(this, "tickPadding", 6);
    _defineProperty(this, "tickValues", null);
    // either set this or set ticks, not both
    _defineProperty(this, "ticks", null);
    // custom properties, not d3 standards
    _defineProperty(this, "majorInnerTickSize", 6);
    _defineProperty(this, "transitionDuration", 0);
    _defineProperty(this, "transitionEase", 'ease-in-out');
    _defineProperty(this, "rotateTicksToFit", RotateOptions.NEVER);
  }
  init(...args) {
    super.init(...args);
    this._scaleChanged();
  }

  // eslint-disable-next-line ember/no-observers
  _scaleChanged() {
    scheduleOnce('afterRender', this, this.draw);
  }
  draw() {
    const scale = this.scale;
    const orient = this.orient;
    const outerTickSize = this.outerTickSize;
    const innerTickSize = this.innerTickSize;
    const tickFormat = this.tickFormat;
    const tickPadding = this.tickPadding;
    const tickValues = this.tickValues;
    const ticks = this.ticks;
    const axis = d3.svg.axis().scale(scale);
    if (!isNone(orient)) {
      axis.orient(orient);
    }
    if (!isNone(outerTickSize)) {
      axis.outerTickSize(outerTickSize);
    }
    if (!isNone(innerTickSize)) {
      axis.innerTickSize(innerTickSize);
    }
    if (!isNone(tickPadding)) {
      axis.tickPadding(tickPadding);
    }
    if (!isNone(tickFormat)) {
      axis.tickFormat(tickFormat);
    }
    if (!isNone(tickValues)) {
      axis.tickValues(tickValues);
    }
    if (ticks && ticks.length > 0 && isNone(tickValues)) {
      axis.ticks(...ticks);
    }
    const element = $(this.element) ? $(this.element).get(0) : undefined; // eslint-disable-line ember/no-jquery
    if (isNone(element)) {
      return;
    }
    if (this.transitionDuration !== 0) {
      d3.select(element).transition().duration(this.transitionDuration).ease(this.transitionEase).call(axis);
    } else {
      d3.select(element).call(axis);
    }
    this.adjustTickLength(element);
    this.attemptToRotateTicks(element, this.rotateTicksToFit);
  }
  adjustTickLength(element) {
    const majorInnerTickSize = this.majorInnerTickSize;
    const tickFormat = this.tickFormat;
    const orient = this.orient;
    if (isNone(majorInnerTickSize) || typeof tickFormat !== 'function') {
      return;
    }
    const sign = ['top', 'left'].includes(orient) ? -1 : 1;
    const attrName = ['bottom', 'top'].includes(orient) ? 'y2' : 'x2';
    // grab all the lines which have a label (tickFormat is not falsy)
    d3.select(element).selectAll('.tick line').filter(tickFormat).each(function () {
      d3.select(this).attr(attrName, sign * majorInnerTickSize);
    });
  }
  maxLabelLength(tickElements) {
    let len = 0;
    tickElements.each(function (label) {
      len = Math.max(len, label.length);
    });
    return len;
  }
  rangeSpan() {
    const range = this.scale.range();
    const x1 = range[0];
    const x2 = range[range.length - 1];
    return Math.abs(x2 - x1);
  }
  attemptToRotateTicks(element, rotateOptions = RotateOptions.NEVER) {
    const tickElements = d3.select(element).selectAll('.tick text');
    if (rotateOptions === RotateOptions.NEVER) {
      return;
    }
    if (rotateOptions === RotateOptions.ALWAYS) {
      this._rotateTicks(tickElements);
      return;
    }
    if (rotateOptions === RotateOptions.AUTO) {
      const maxLabelLength = this.maxLabelLength(tickElements);
      const numTicks = tickElements[0].length;
      const spaceForLabels = this.rangeSpan();
      const spacePerLabel = spaceForLabels / numTicks;
      const spacePerCharacter = spacePerLabel / maxLabelLength;
      if (spacePerCharacter < MIN_SPACE_PER_CHAR) {
        this._rotateTicks(tickElements);
      } else {
        this._unRotateTicks(tickElements);
      }
    }
  }
  _rotateTicks(tickElements) {
    return tickElements.attr('transform', 'translate(-12, 0) rotate(-45, 0, 0)').style('text-anchor', 'end');
  }
  _unRotateTicks(tickElements) {
    return tickElements.attr('transform', '').style('text-anchor', 'middle');
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "transform", [attribute], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "_scaleChanged", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "_scaleChanged"), _class2.prototype), _class2)) || _class) || _class);
export { SqChartAxis as default };